export default __webpack_public_path__ + "static/mortgages-6d6b9d33773fd785a7da5e67347f96ab.png";